<template>
   <div class="center-vertical no-scroll" id="confirmed-in-game">
    <div class="confirmed-in-game-header">
        <span v-if="!connected">Connecting...</span>
        <span v-if="connected">Connected!</span>
        <br/>
        <span class="sub-header" v-if="!connected">Establishing connection...</span>
        <span class="sub-header" v-if="connected">Waiting for your friends...</span>
    </div>
    <div class="avatar">
        <!-- IMPT: Image and name will change according to what player is assigned -->
        <img :src="playerAvatar" >
        <div>{{this.playerName}}</div>
    </div>
    <div class="room-code">
      <span>Room Code: {{this.roomId}}</span>
    </div>
    <div class="disclaimer">
        <span>Once all your players are in, </span>
        <br/>
        <span>press START GAME on the big screen!</span>
    </div>
</div>
</template>

<style lang="scss" scoped>
.confirmed-in-game-header {
  font-size: 40px;
  text-align: center;

  .sub-header {
    font-size: 20px;
  }
}

.room-code {
  font-size: 1.2em;
  margin-top: 10%;
  color: #e13d61;
}

.avatar {
  text-align: center;
  margin-top: 10%;
}
.disclaimer {
  text-align: center;
  margin-top: 10%;
}

img {
  margin-bottom: 10%;
}
</style>
<script>
import SumoClient from '@/assets/js/SumoClient.js'
import Shake from 'shake.js'
import orangeSumo from '@/assets/join-room/player1.png'
import greenSumo from '@/assets/join-room/player2.png'
import blueSumo from '@/assets/join-room/player3.png'
import purpleSumo from '@/assets/join-room/player4.png'
import loadingCat from '@/assets/confirm-in-game/loading.svg'

export default {
  mounted: function() {
    // has existing connection already
    if(this.clientConnection) return

    this.playerAvatar = loadingCat

    this.clientConnection = new SumoClient(this.$firebase, this.playerName, this.roomId);
    
    this.clientConnection.onDisconnected = () => {
        this.stopAllSensors();
        this.goToDisconnected()
    }
    this.clientConnection.onConnected = () => {
        this.connected = true
    }

    this.clientConnection.onHostData = data => {

      try{
        const json = JSON.parse(data)
        const type = json.type
        const payload = json.payload
        switch(type) {
            case "gameChanged":
                // stop all sensors because we might switch games without going to joinRoom
                this.stopAllSensors();


                // json.payload is in form below.

                /*
                    {
                        game: "Flappy Sumo / Sumo Ring",
                        mode: "shake / tilt",
                    }
                 */
                if(payload.game === "Flappy Sumo" && payload.mode === "shake") {
                  this.startShakeDetection();
                }

                if((payload.game === "Sumo Ring" || payload.game === "Sumo Ball") && payload.mode === "tilt") {
                  // start tilt detection
                    this.startTiltDetection();
                }

                console.log("Game was changed to", payload.game);
                break;
            case "playerAdded":
                // json.payload is in form below.
                // TODO: Change state from connecting to connected/rejected
                // 0-4 int indicates player number. Use this to set player assets (color)
                /*
                    {
                        type: "playerAdded"
                        payload: {
                            success: true/false,
                            index: 0-4 int,
                        }
                    }
                 */
                if(payload.success){
                  const avatars = [orangeSumo, greenSumo, blueSumo, purpleSumo]
                  this.playerAvatar = avatars[payload.index]
                }

                console.log("didGetAddedToGame:", json.payload.success.toString());
                break;
            case "restartRoom":
                // no payload
                this.roomId = payload.roomId

                this.stopAllSensors()

                this.goToJoinRoom()
                break;
            case "gameStart":
                
                if(payload.game === "Flappy Sumo") {
                    this.goToInGame()
                }else if(payload.game === "Sumo Ring"){
                    this.goToInGameSumoRing()
                }else if(payload.game === "Sumo Ball"){
                    this.goToInGameSumoBall()
                }
                break;
            case "gameStop":
                this.goToGameOver();
                break;
            case "tutorialStart":
                if(payload.game === "Flappy Sumo") {
                    // do nothing
                }else if(payload.game === "Sumo Ring"){
                    this.goToSumoRingTutorial()
                }else if(payload.game === "Sumo Ball"){
                    this.goToSumoBallTutorial()
                }
                break;
            default:
                break;
        }
      } catch (e) {
        console.log("cannot parse json:" + data );
      }

    };

    this.clientConnection.start();
  },
  methods: {
    goToJoinRoom: function() {
      this.$router.replace('join-room')
    },
    goToInGame: function() {
      this.$router.replace("in-game")
    },
    goToInGameSumoRing: function() {
      this.$router.replace("in-game-sumo-ring")
    },
    goToInGameSumoBall: function() {
      this.$router.replace("in-game-sumo-ball")
    },
    goToDisconnected: function() {
      this.$router.replace('disconnected')
    },
    goToGameOver: function() {
      this.$router.replace('game-over')
    },
    goToSumoRingTutorial: function() {
      this.$router.replace('tutorial-sumo-ring')
    },
    goToSumoBallTutorial: function() {
      this.$router.replace('tutorial-sumo-ball')
    },
    startShakeDetection: function() {
      var self = this
        console.log("in shake detection");
      console.log(this.shakeListener);
      if(this.shakeListener) {
          this.shakeListener.start();
          return;
      }

      this.shakeListener = new Shake({
          timeout: 100,
          threshold: 10
      });
      this.shakeListener.start();
        console.log("did try to start shake listener");
        console.log(this.shakeListener);
      window.addEventListener('shake', function() {
          //function to call when shake occurs
          console.log("shake");
          self.$store.state.clientConnection.send(JSON.stringify({
              type: "shake",
              user: self.playerName,
              payload: "shakeSent"
          }));
      }, false);
    },
    startTiltDetection: function() {
        if (this.tiltInterval) {
            return;
        }

        // Listener to tilt event and stores data to a caching variable
        window.addEventListener('deviceorientation', e => {
            this.tiltSensorVal = e
        }, false);

         // Poll the caching variable at a required rate
        this.tiltInterval = setInterval(() => {
            let tiltData = this.tiltSensorVal
            if (tiltData != null) {
                // Beta is +-180, gamma is +-90
                // Let's remap it to be +-45 for beta, and 22.5 for gamma
                let tiltLR = tiltData.beta * 4;
                let tiltFB = -tiltData.gamma * 8;

                let tiltLRAbs = Math.abs(tiltLR);
                let tiltFBAbs = Math.abs(tiltFB);

                tiltLR = tiltLRAbs >= 180 ?
                    (tiltLR < 0 ? -180 : 180) :
                    tiltLR;

                tiltFB = tiltFBAbs >= 180 ?
                    (tiltFB < 0 ? -180 : 180) :
                    tiltFB;

                let jsonPayload = tiltLR.toString() + "|" + tiltFB.toString();
                this.clientConnection.send(JSON.stringify({
                    type: "tilt",
                    user: this.playerName,
                    payload: jsonPayload,
                }));
            }

        }, 100);   
    },
    stopAllSensors: function() {
        if (this.shakeListener) {
            this.shakeListener.stop();
        }
        if (this.tiltInterval) {
            clearInterval(this.tiltInterval);
            this.tiltInterval = null;
        }
    }
  },
  computed: {
      playerName: {
        get() { return this.$store.state.playerName }
      },
      roomId: {
        get() { return this.$store.state.roomId },
        set(value) { this.$store.commit('updateRoomId', value) }
      },
      clientConnection: {
        get() { return this.$store.state.clientConnection },
        set(value) { this.$store.commit('updateClientConnection', value) }
      },
      playerAvatar: {
        get() { return this.$store.state.playerAvatar },
        set(value) { this.$store.commit('updatePlayerAvatar', value) }
      },
      shakeListener: {
        get() { return this.$store.state.shakeListener },
        set(value) { this.$store.commit('updateShakeListener', value) }
      },
      tiltInterval: {
        get() { return this.$store.state.tiltInterval },
        set(value) { this.$store.commit('updateTiltInterval', value) }
      }
  },
  data: function() {
      return {
          tiltSensorVal: null,
          connected: false
      }
  }
}
</script>
